import { displayOwner } from '../Admin/ContentOwnership/contentOwnershipApi';

export const MAX_EXPORT_RECORDS = 10000;
export const EXPORT_PAGE_SIZE = 100;

const sanitizeExportText = (value) =>
  String(value ?? '').replace(/[\u0000-\u001F\u007F-\u009F]/g, '').trim();

const resolveObjectType = (item = {}) => {
  if (item.objectType) {
    return sanitizeExportText(item.objectType);
  }
  if (item.isFile === true) {
    return 'File';
  }
  if (item.isFile === false) {
    return 'Folder';
  }
  return '';
};

export const mapOwnershipToExportRow = (item = {}) => ({
  Type: resolveObjectType(item),
  Name: sanitizeExportText(item.name),
  'Create Owner': displayOwner(item.createdOwner),
  'Modify Owner': displayOwner(item.modifiedOwner),
  Path: sanitizeExportText(item.relativePath)
});

export const hasActiveOwnershipFilters = (filters = {}) => {
  const type = filters.type || 'all';
  const extension = filters.extension;
  const hasExtensionFilter = Array.isArray(extension)
    ? extension.length > 0
    : Boolean(extension && extension !== 'all');
  const level =
    filters.level === undefined || filters.level === null || filters.level === ''
      ? '0'
      : String(filters.level);

  return Boolean(
    type !== 'all'
    || hasExtensionFilter
    || level !== '0'
  );
};

const getTimestamp = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');

  return `${year}${month}${day}_${hours}${minutes}`;
};

export const buildExportFilename = (filters = {}) => {
  const base = `ContentOwnership_Export_${getTimestamp()}`;

  if (hasActiveOwnershipFilters(filters)) {
    return `${base}_filtered.xlsx`;
  }

  return `${base}.xlsx`;
};

export const validateExportRecordCount = (count) => {
  if (count > MAX_EXPORT_RECORDS) {
    throw new Error('Too many records; narrow filters');
  }
};
